var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgJp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "jp_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.7,
  d: "M177.2 0h708.6v708.7H177.2z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  strokeWidth: "1pt",
  clipPath: "url(#jp_svg__a)",
  transform: "translate(-128)scale(.72249)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h1063v708.7H0z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 523.1,
  cy: 344.1,
  r: 194.9,
  fill: "#bc002d",
  transform: "translate(-59.7 -34.5)scale(1.1302)"
}))));
export default SvgJp;